import * as React from 'react'
import { SVGProps } from 'react'
export const IconSchool = (props: SVGProps<SVGSVGElement>): JSX.Element => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 128 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M104.246 70.274V85.26c0 3.894-2.133 7.52-5.546 9.387l-26.667 14.56a10.59 10.59 0 0 1-10.24 0l-26.667-14.56c-3.413-1.867-5.546-5.493-5.546-9.387V70.274l32.213 17.6a10.59 10.59 0 0 0 10.24 0l32.213-17.6Zm-32.213-51.52 44.96 24.533c3.68 2.027 3.68 7.36 0 9.387l-44.96 24.533a10.59 10.59 0 0 1-10.24 0l-42.88-23.413v31.52c0 2.933-2.4 5.333-5.333 5.333-2.934 0-5.334-2.4-5.334-5.333V51.127c0-1.973 1.067-3.733 2.774-4.693l50.773-27.68a10.88 10.88 0 0 1 10.24 0Z"
        fill="currentColor"
      />
    </svg>
  )
}
